import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeCommentContentItemContent$key } from "~/queries/__generated__/homeCommentContentItemContent.graphql";

import {
  ActionBar,
  AuthorImages,
  AuthorLinks,
  Container,
  Content,
  ContentContainer,
  Headline,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeCommentContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeComment = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeCommentContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <ContentContainer>
          <Content>
            <AuthorLinks onClick={() => onClick?.(content.entityId)}>
              {provider.authorLink?.({ ignoreAuthorType: true, isMultiple: true })}
            </AuthorLinks>
            <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
              <Headline>{provider.headline({ preferSocialHeadline: true })}</Headline>
            </StyledEntityLink>
          </Content>
          <AuthorImages>
            {provider.authorImage?.({
              ignoreAuthorType: true,
              isMultiple: true,
              withOutline: true,
            })}
          </AuthorImages>
        </ContentContainer>
        <ActionBar>
          {provider.actionBar({
            isBookmarkVisible: false,
            isIconVisible: false,
            variant: "home",
          })}
        </ActionBar>
      </Container>
    );
  },
);

ContentItemHomeComment.displayName = "ContentItemHomeComment";
